<template>
  <LayoutShellFlat>
    <template #nav>
      <NavBarSystemAdminSettings />
    </template>
    <slot />
  </LayoutShellFlat>
</template>
